<template>
  <CRow>
    <CCol xs="12" sm="12" md="12" lg="4" xl="3">
      <CCard>
        <CCardHeader class="d-flex justify-content-between">
          <b><i class="fas fa-filter"></i>&nbsp;filtro</b>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol lg="6" md="6" sm="12">
              <CSelect
                label="Mes"
                :value.sync="filter.month"
                :options="months"
                placeholder="--Seleccione un mes--"
              />
            </CCol>
            <CCol xs="6" sm="12" md="6" lg="6">
              <CSelect
                label="Mes"
                :value.sync="filter.year"
                :options="years"
                placeholder="--Seleccione un año--"
              />
            </CCol>
            <CCol xs="12" sm="12" md="12" lg="12">
              <CButton
                type="button"
                color="info"
                size="sm"
                @click="mtdGetData"
                class="w-100"
              >
                <i class="fas fa-search"></i> Consultar
              </CButton>
            </CCol>
            <CCol xs="12" sm="6" md="6" lg="12">
              <CInput
                label="Total de Ventas"
                type="text"
                size="sm"
                v-model="sumaTotal"
                disabled
              />
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol xs="12" sm="12" md="12" lg="8" xl="9">
      <CTableWrapper
        :items="data"
        :fields="fields"
        hover
        :striped="true"
        :border="true"
        small
        fixed
        caption="Lista de remuneraciones del mes"
        icon="fas fa-coins"
        @mtdBack="mtdBack"
        :size="'md'"
        :withActions="'1%'"
        :actions="true"
        :button_new="true"
        :btn_name="'sueldo'"
        @show_modal="mtd_open_modal"
        :buttonEdit="true"
        :buttonDelete="true"
        @action_edit="mtd_show"
        @action_delete="mtd_delete"
      />
    </CCol>
    <!-- modal -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow class="flex">
        <CCol xl="6" lg="6" md="6" sm="12" xs="12">
          <CSelect
            label="Mes"
            :value.sync="remuneration.month"
            :options="months"
            placeholder="--Seleccione un mes--"
          />
        </CCol>
        <CCol xl="6" lg="6" md="6" sm="12" xs="12">
          <CSelect
            label="Año"
            :value.sync="remuneration.year"
            :options="years"
            placeholder="--Seleccione un año--"
          />
        </CCol>
        <CCol sm="12">
          <CSelect
            label="Personal"
            :value.sync="remuneration.user"
            :options="personalOptions"
            placeholder="--Seleccione un personal--"
          />
        </CCol>
        <CCol sm="6">
          <CInput
            label="Sueldo base"
            placeholder="Digite base"
            v-model="remuneration.base"
          />
        </CCol>
        <CCol sm="6">
          <CInput
            label="Comisiones"
            placeholder="Digite comision"
            v-model="remuneration.comission"
          />
        </CCol>
        <CCol sm="6">
          <CInput
            label="Horas extas"
            placeholder="Digite dirección"
            v-model="remuneration.hour_extra"
          />
        </CCol>
        <CCol lg="6" md="6" sm="6">
          <CInput
            label="Descuento por retrasos"
            placeholder="Digite retraso"
            v-model="remuneration.retrasos"
          />
        </CCol>
        <CCol lg="12" md="12" sm="12">
          <CInput
            label="Total"
            placeholder="Total"
            disabled
            v-model="cpTotal"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Cliente'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />
  </CRow>
</template>

<script>
import { mapActions } from "vuex";
import CTableWrapper from "../../../shared/datatable/Table.vue";
import CModalForm from "../../../shared/modals/cModalForm.vue";
import cModalDelete from "../../../shared/modals/cModalDelete.vue";

const fields = [
  { key: "Id", label: "Id", _style: "width:1%" },
  { key: "name", label: "Personal", _style: "width:10%;" },
  { key: "total", label: "Sueldo", _style: "width:5%;" },
];

export default {
  name: "c-proccess-remuration",
  components: { CTableWrapper, CModalForm, cModalDelete },
  data() {
    return {
      prefix: "remuneration",
      fields,
      months: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      years: [2026],
      personals: [],
      filter: {
        month: null,
        year: null,
      },
      sumaTotal: 0,
      data: [],
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      remuneration: {
        id: "",
        company_id: this.$store.getters.get_company.id,
        user: "",
        month: "",
        year: "",
        base: "",
        comission: "",
        hour_extra: "",
        retrasos: "",
        total: 0,
      },
      modal_delete: {
        boo: false,
        item: [],
      },
    };
  },
  computed: {
    cp_button: function () {
      return !(
        this.remuneration.name !== "" && this.remuneration.document !== ""
      );
    },
    personalOptions() {
      return this.personals.map((p) => ({
        value: p.id,
        label: `${p.name} ${p.last_name}`,
      }));
    },
    cpTotal() {
      const n = (v) => parseFloat(v) || 0;

      const total =
        n(this.remuneration.base) +
        n(this.remuneration.comission) +
        n(this.remuneration.hour_extra) -
        n(this.remuneration.retrasos);

      this.remuneration.total = total.toFixed(2);
      return this.remuneration.total;
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack: function () {
      this.$emit("returnHome");
    },
    mtdGetData: function () {
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/index/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
        params: this.filter,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.personals = response.data.user;
            this.data = response.data.data;
          }
        })
        .catch((errors) => {});
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nuevo(a) Sueldo")
        : (this.modal.title = "Editar Sueldo");
      if (action == "store") {
        this.remuneration = {
          id: "",
          company_id: this.$store.getters.get_company.id,
          user: "",
          month: "",
          year: "",
          base: "",
          comission: "",
          hour_extra: "",
          retrasos: "",
          total: 0,
        };
      } else {
        this.remuneration = this.remuneration;
      }
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_action: function () {
      this.post({
        url: `${this.$store.getters.get__url}/${this.prefix}/${this.modal.action}`,
        token: this.$store.getters.get__token,
        params: this.remuneration,
      })
        .then((response) => {
          if (response.data.state == 1) {
            Swal.fire({ title: "Sueldo ya registrado", icon: "warning" });
          } else if (response.statusCode == 200) {
            const message =
              this.modal.action == "store"
                ? "REGISTRADO CORRECTAMENTE"
                : "EDITADO CORRECTAMENTE";
            const color = "success";
            if (this.modal.action == "store") {
              this.mtdGetData();
            } else {
              this.data = this.data.map((element) =>
                element.Id == response.data[0].Id
                  ? { ...element, ...response.data[0] }
                  : element
              );
              this.componentKey += 1; // Forzar re-renderización
            }
            this.modal = { action: "", title: "", modal_form: false };
            Swal.fire({
              title: message,
              icon: color,
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "warning",
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.remuneration = response;
          let date_convert = this.getYearAndMonthName(response.date);
          this.remuneration.month= date_convert.month;
          this.remuneration.year = date_convert.year;
          this.remuneration.user = parseInt(response.user_id);
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      })
        .then((response) => {
          this.mtdGetData();
          this.modal_delete = {
            boo: false,
            item: [],
          };
          Swal.fire({
            title: "ELIMINADO CORRECTAMENTE",
            icon: "success",
          });
        })
        .catch((errors) => {});
    },
    getYearAndMonthName(dateStr) {
      const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];

      const date = new Date(dateStr + "T00:00:00"); // evita problemas de zona horaria
      const year = date.getFullYear();
      const monthName = months[date.getMonth()]; // getMonth() => 0-11

      return { year, month: monthName };
    },
  },
};
</script>

<style lang="scss" scoped>
</style>